import React, { useEffect } from 'react';
import { Nav, Navbar, Button } from 'react-bootstrap';
import petrollLogo from "../assets/images/Petroll Logo small.png";
import { useLocation, useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";

const NavbarComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Auto-redirect to login if token expired or missing
  useEffect(() => {
    const token = Cookies.get("token");

    if (!token) {
      navigate("/");
    }
  }, [navigate]);

  // Logout function
  const handleLogout = () => {
    Cookies.remove("token");      // remove token
    navigate("/");           // redirect to login
  };

  return (
    <>
      <Navbar
        expand="lg"
        bg="white"
        fixed="top"
        className="shadow-sm px-4 py-2 border-bottom custom-navbar"
      >
        {/* Logo */}
        <Navbar.Brand className="d-flex align-items-center fw-bold">
          <img
            src={petrollLogo}
            alt="Petroll Logo"
            style={{ height: "42px" }}
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="admin-navbar" />

        <Navbar.Collapse id="admin-navbar">
          <Nav className="ms-auto align-items-lg-center gap-lg-4">

            {[
              { label: "Pets", path: "/pets" },
              { label: "Users", path: "/users" },
              { label: "Plans", path: "/pricing-plans" },
              { label: "Premium", path: "/request-premiums" },
              { label: "Payments", path: "/payments" },
              { label: "Ads", path: "/ads" },
              { label: "Contact", path: "/contact-messages" }
            ].map((navItem) => (
              <Nav.Link
                key={navItem.path}
                href={navItem.path}
                className={`nav-link-custom ${location.pathname === navItem.path ? "active-link" : ""
                  }`}
              >
                {navItem.label}
              </Nav.Link>
            ))}

            {/* Divider */}
            <div className="vr mx-3 d-none d-lg-block" />

            {/* Logout */}
            <Button
              className="logout-btn"
              onClick={handleLogout}
            >
              Logout
            </Button>

          </Nav>
        </Navbar.Collapse>
      </Navbar>

      {/* Spacer */}
      <div style={{ height: "80px" }} />

      {/* Custom Styles */}
      <style>{`
    .custom-navbar {
      backdrop-filter: blur(10px);
      background: rgba(255, 255, 255, 0.9) !important;
    }

    /* Nav links */
    .nav-link-custom {
      font-weight: 600;
      font-size: 15px;
      color: #333 !important;
      position: relative;
      padding: 6px 4px;
      transition: all 0.3s ease;
    }

    /* Hover effect */
    .nav-link-custom:hover {
      color: #e07b39 !important;
      transform: translateY(-1px);
    }

    /* Underline animation */
    .nav-link-custom::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: -6px;
      width: 0%;
      height: 3px;
      background: #e07b39;
      border-radius: 2px;
      transition: width 0.3s ease;
    }

    .nav-link-custom:hover::after {
      width: 100%;
    }

    /* Active link */
    .active-link {
      color: #e07b39 !important;
    }

    .active-link::after {
      width: 100%;
    }

    /* Logout button */
    .logout-btn {
      background: linear-gradient(135deg, #ff6a00, #ff8c42);
      border: none;
      font-weight: 600;
      padding: 8px 18px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(255, 106, 0, 0.4);
      transition: all 0.3s ease;
    }

    .logout-btn:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(255, 106, 0, 0.6);
    }
  `}</style>
    </>


  );
};

export default NavbarComponent;
